@if (isLoading) {
  <div class="loading-container" style="display: flex; justify-content: center; align-items: center; height: 100vh; flex-direction: column;">
    <mat-spinner></mat-spinner>
    <p style="margin-top: 20px;">Loading your payment details...</p>
  </div>
} @else {
  <div class="page__header">
  <div class="page__header-flex">
    <div class="page__header-left" (click)="router.navigate(['/dashboard'])" style="cursor: pointer">
      <div class="logo">
        <img src="assets/logos/freely-logo-black.svg" alt="History" style="width: 200px; height: auto;"/>
        <div class="logo__slogan">accept</div>
      </div>
    </div>
    <div class="page__header-right">
      <button mat-stroked-button routerLink="/history">exit</button>
    </div>
  </div>
</div>

<!-- Declined before reaching the processor (duplicate / already paid): no transaction to show -->
@if (isDeclinedWithoutTransaction) {
  <div class="success-hero success-hero--failed">
    <div class="success-hero__media">
      <img src="assets/error_icon.svg" alt="Declined"/>
    </div>
    <div class="success-hero__content">
      <h2 class="success-hero__title" style="padding-left: 16px;">Payment Declined</h2>
      <div class="success-hero__subtitle" style="padding-left: 16px;">
        The payment was declined. Nothing was charged.
      </div>
    </div>
  </div>

  <div class="success-footer">
    <div class="success-footer__actions">
      <button mat-raised-button color="primary" routerLink="/payment/collect">Collect Another Payment</button>
      <button mat-raised-button color="secondary-inversed" routerLink="/history">View Transactions</button>
    </div>
  </div>
} @else if (isMultiInvoice) {
  <div class="success-hero" [ngClass]="{'success-hero--failed': multiInvoiceFailCount > 0}">
    <div class="success-hero__media">
      <img [src]="multiInvoiceFailCount === 0 ? 'assets/storm-small.svg' : 'assets/error_icon.svg'"
           [alt]="multiInvoiceFailCount === 0 ? 'Success' : 'Partial Success'"/>
    </div>
    <div class="success-hero__content">
      <h2 class="success-hero__title" style="padding-left: 16px;">
        @if (isCreditApplied) {
          Credit Applied
        } @else if (multiInvoiceFailCount === 0 && multiInvoiceSuccessCount === 0 && onAccountAmount > 0) {
          Payment Applied to Account
        } @else if (multiInvoiceFailCount === 0) {
          Multi-Invoice Payment Complete
        } @else if (multiInvoiceSuccessCount > 0) {
          Multi-Invoice Payment Partially Completed
        } @else {
          Multi-Invoice Payment Failed
        }
      </h2>
      <div class="success-hero__subtitle" style="padding-left: 16px;">
        @if (isCreditApplied) {
          Credit was applied to {{ multiInvoiceSuccessCount }} invoice(s) — nothing was charged.
          @if (creditPaymentId) {
            <br />Recorded as payment {{ creditPaymentId }}.
          }
        } @else if (multiInvoiceSuccessCount === 0 && multiInvoiceFailCount === 0 && onAccountAmount > 0) {
          {{ onAccountAmount | currency }} was applied to the customer's account.
        } @else if (multiInvoiceSuccessCount > 0 && multiInvoiceFailCount === 0) {
          Successfully processed {{ multiInvoiceSuccessCount }} invoice(s)
          @if (onAccountAmount > 0) {
            , and {{ onAccountAmount | currency }} applied to the account
          }
        } @else if (multiInvoiceSuccessCount > 0 && multiInvoiceFailCount > 0) {
          Successfully processed {{ multiInvoiceSuccessCount }} invoice(s), {{ multiInvoiceFailCount }} failed
        } @else {
          Failed to process {{ multiInvoiceFailCount }} invoice(s)
        }
      </div>
    </div>
  </div>

  <div class="success-footer">
    <div class="success-footer__actions">
      <button mat-raised-button color="primary" routerLink="/payment/collect">Collect Another Payment</button>
      <button mat-raised-button color="secondary-inversed" routerLink="/history">View Transactions</button>
    </div>
  </div>
} @else {

<!-- Single Transaction View -->
<div class="success-hero" [ngClass]="{'success-hero--failed': !isTransactionSuccess}">
  <div class="success-hero__media">
    <img [src]="(isTransactionSuccess || flashpayResponse?.createdAt)
              ? 'assets/storm-small.svg'
              : 'assets/error_icon.svg'"
         [alt]="(isTransactionSuccess || flashpayResponse?.createdAt)
              ? 'Success'
              : 'Failed'"/>
  </div>
  <div class="success-hero__content">
    <h2 class="success-hero__title" style="padding-left: 16px;">
      <ng-container *ngIf="route.snapshot.queryParams['view'] === 'flashpay'; else regularTransaction">
        <ng-container *ngIf="flashpayResponse?.createdAt; else failedTitle">
          Success! Flashpay ID {{ flashpayResponse?.flashPayId }}
        </ng-container>
      </ng-container>
      <ng-template #regularTransaction>
        <ng-container *ngIf="isTransactionSuccess; else failedTitle">
          Success! Confirmation ID {{ transaction?.transactionResult?.authorizationCode }}
        </ng-container>
      </ng-template>
      <ng-template #failedTitle>
        Transaction Failed
      </ng-template>
    </h2>
    <div class="success-hero__subtitle" style="padding-left: 16px;">
      <ng-container *ngIf="route.snapshot.queryParams['view'] === 'flashpay'; else regularTransactionId">
        <ng-container *ngIf="flashpayResponse?.createdAt; else failedMessage">
          Open or copy your flashpay link here:
          <a [routerLink]="['/flashpay']" 
             [queryParams]="{ link: flashpayResponse?.flashPayLink }" target="_blank" rel="noopener noreferrer"
             style="color: blue; text-decoration: underline; cursor: pointer; margin-right: 8px;"
             [title]="flashpayResponse?.flashPayLink">
            Flashpay Link
          </a>
          <mat-icon 
            (click)="copyToClipboard(flashpayResponse?.flashPayLink)"
            style="cursor: pointer; font-size: 18px; vertical-align: middle;"
            [matTooltip]="'Copy to clipboard'"
          >
            content_copy
          </mat-icon>
        </ng-container>
      </ng-container>
      <ng-template #regularTransactionId>
        <ng-container *ngIf="isTransactionSuccess; else failedMessage">
          Your transaction number is {{ transaction?.transactionId }}
        </ng-container>
      </ng-template>
      <ng-template #failedMessage>
        {{ transaction?.transactionResult?.resultCode || 'not found' }}:  {{ transaction?.transactionResult?.resultMessage || 'not found' }}
      </ng-template>
    </div>
    @if (route.snapshot.queryParams['view'] === 'flashpay' && flashpayResponse?.flashPayMode === 'advanced') {
      <!-- Advanced FlashPay: the invoices this link was sent with. -->
      <div class="success-hero__subtitle" style="padding-left: 16px; margin-top: 12px;">
        Sent to {{ flashpayResponse?.customerEmailAddress }} with {{ flashpayResponse?.invoiceCount }} invoice(s),
        valid until {{ flashpayResponse?.expiresDateTime | date : 'mediumDate' }}:
        <table style="margin-top: 8px; border-collapse: collapse;">
          @for (invoice of flashpayResponse?.invoices ?? []; track invoice.invoiceRef) {
            <tr>
              <td style="padding: 2px 16px 2px 0;">{{ invoice.invoiceRef }}</td>
              <td style="padding: 2px 0; text-align: right;">{{ invoice.amountAtSend | currency }}</td>
            </tr>
          }
          <tr>
            <td style="padding: 4px 16px 2px 0; font-weight: 600;">Total</td>
            <td style="padding: 4px 0 2px; text-align: right; font-weight: 600;">{{ flashpayResponse?.paymentAmountRequested | currency }}</td>
          </tr>
        </table>
      </div>
    }
  </div>
  <div class="success-hero__actions">
    <button 
      mat-button 
      color="primary" 
      type="button"
      (click)="downloadReceipt(transaction!)"
      [style.display]="route.snapshot.queryParams['view'] === 'flashpay' ? 'none' : 'block'" 
      [disabled]="!transaction?.transactionId"
    >
      download receipt
    </button>
  </div>
</div>

<!-- Customer and Payment Details - Only for single transactions -->
<div class="container">
  <div class="row">
    <div class="col-6 flex">
      <div class="panel flex-grow">
        <div class="panel__title">Customer Details</div>
        <div class="panel__content">
          <dl class="dl-table container">
            <div class="row">
              <dt class="col-4"><span>Customer name:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.freelyCustomerDetails?.displayName 
                : transaction?.customerDetails?.displayName }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Account number:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.freelyCustomerDetails?.companyAccountNumber 
                : transaction?.customerDetails?.companyAccountNumber }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Email address:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.customerEmailAddress 
                : transaction?.customerDetails?.contactEmail }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Last name:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.freelyCustomerDetails?.contactLastName 
                : transaction?.customerDetails?.contactLastName }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>First name:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.freelyCustomerDetails?.contactFirstName 
                : transaction?.customerDetails?.contactFirstName }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Business phone:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.freelyCustomerDetails?.contactPhoneNumber 
                : transaction?.customerDetails?.contactPhoneNumber }}</span></dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Mobile phone:</span></dt>
              <dd class="col-8"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                ? flashpayResponse?.mobilePhoneNumber 
                : transaction?.customerDetails?.mobilePhoneNumber }}</span></dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="panel">
              <div class="panel__title">Payment Details</div>
              <div class="panel__content">
                <div class="container">
                  <div class="row">
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row">
                          <dt class="col-7">
                            <span>{{ 
                              route.snapshot.queryParams['view'] === 'flashpay'
                                ? 'Payment Type:' 
                                : route.snapshot.queryParams['view'] === 'saleAch'
                                  ? 'Payment Type:'
                                  : route.snapshot.queryParams['view'] === 'sale'
                                    ? 'Card Type:'
                                    : 'Type:'

                            }}</span>
                          </dt>
                          <dd class="col-5">
                            <span>{{ 
                              route.snapshot.queryParams['view'] === 'flashpay'
                                ? 'Flashpay Link'
                                : route.snapshot.queryParams['view'] === 'saleAch'
                                  ? transaction?.cardDetails?.cardType
                                  : transaction?.cardDetails?.cardType
                            }}</span>
                          </dd>
                        </div>
                        
                        <!-- Show ACH details if ACH payment mode -->
                        <ng-container *ngIf="route.snapshot.queryParams['view'] === 'saleAch'; else cardPayment">
                          <div class="row">
                            <dt class="col-7"><span>Account Number:</span></dt>
                            <dd class="col-5">
                              <span>{{ transaction?.cardDetails?.cardNumberRedacted }}</span>
                            </dd>
                          </div>
                          <div class="row">
                            <dt class="col-7"><span>Routing Number:</span></dt>
                            <dd class="col-5">
                              <span>{{ transaction?.achDetails?.abaRoute }}</span>
                            </dd>
                          </div>
                        </ng-container>
                        
                        <ng-template #cardPayment>
                          <!-- Show card details for credit card payment mode -->
                          <ng-container *ngIf="route.snapshot.queryParams['view'] !== 'flashpay' && route.snapshot.queryParams['view'] !== 'error'; else error">
                            <div class="row">
                              <dt class="col-7"><span>Card number:</span></dt>
                              <dd class="col-5">
                                <span>{{ transaction?.cardDetails?.cardNumberRedacted }}</span>
                              </dd>
                            </div>
                            <div class="row">
                              <dt class="col-7"><span>Card expiration:</span></dt>
                              <dd class="col-5">
                                <span>{{ transaction?.cardDetails?.cardExpiration ? (transaction?.cardDetails?.cardExpiration | cardExpiration:getCardExpirationOptions()) : '' }}</span>
                              </dd>
                            </div>
                          </ng-container>
                        </ng-template>

                        <ng-template #error>
                          <div class="row">
                            <dt class="col-7"><span>Number:</span></dt>
                            <dd class="col-5">
                              <span>{{ transaction?.cardDetails?.cardNumberRedacted }}</span>
                            </dd>
                          </div>
                        </ng-template>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="panel">
              <div class="panel__title">
                <ng-container *ngIf="route.snapshot.queryParams['view'] === 'preAuth'; else invoiceTitle">
                  Requested Amount
                </ng-container>
                <ng-template #invoiceTitle>
                  <ng-container *ngIf="route.snapshot.queryParams['view'] === 'completeAuth'; else refundTitle">
                    Authorization Details
                  </ng-container>
                  <ng-template #refundTitle>
                    <ng-container *ngIf="route.snapshot.queryParams['view'] === 'refund'; else defaultTitle">
                      Refund Details
                    </ng-container>
                    <ng-template #defaultTitle>Invoice Details</ng-template>
                  </ng-template>
                </ng-template>
              </div>
              <div class="panel__content">
                <div class="container">
                  <div class="row">
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Invoice Number:</span></dt>
                          <ng-container *ngIf="(transaction?.paymentDetails?.reference?.length || flashpayResponse?.referenceNumber?.length || 0) > 10">
                            <p>&nbsp;</p>
                          </ng-container>
                          <dd class="col-5"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                            ? flashpayResponse?.referenceNumber 
                            : transaction?.paymentDetails?.reference }}</span></dd>
                        </div>
                        <div class="row">
                          <dt class="col-7">
                            <span>{{ 
                              route.snapshot.queryParams['view'] === 'preAuth'
                                ? 'Pre-Authorized Amount:' 
                                : route.snapshot.queryParams['view'] === 'completeAuth'
                                  ? 'Authorization Amount:'
                                  : route.snapshot.queryParams['view'] === 'refund'
                                    ? 'Refund Amount:'
                                    : 'Invoice Total:'
                            }}</span>
                          </dt>
                          <dd class="col-5"><span>{{ 
                            route.snapshot.queryParams['view'] === 'flashpay'
                              ? (Number(flashpayResponse?.paymentAmountRequested) - Number(flashpayResponse?.costOfCapitalAmountRequested) | currency)
                              : route.snapshot.queryParams['view'] === 'preAuth'
                                ? (transaction?.transactionResult?.authorizedAmount ?? 0.00 | currency)
                                : route.snapshot.queryParams['view'] === 'refund'
                                  ? (transaction?.transactionResult?.authorizedAmount ?? 0.00 | currency)
                                  : (transaction?.paymentDetails?.totalApplied ?? 0.00 | currency) 
                          }}</span></dd>
                        </div>
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth' && !hideTax">
                          <dt class="col-7"><span>Tax:</span></dt>
                          <dd class="col-5"><span>{{ route.snapshot.queryParams['view'] === 'flashpay'
                            ? (flashpayResponse?.taxAmountRequested | currency)
                            : (transaction?.paymentDetails?.totalTax ?? 0.00 | currency) }}</span></dd>
                        </div>
                      </dl>
                    </div>
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Capital:</span></dt>
                          <dd class="col-5"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                            ? (flashpayResponse?.costOfCapitalAmountRequested | currency) 
                            : (transaction?.paymentDetails?.costOfCapital ?? 0.00 | currency) }}</span></dd>
                        </div>
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Shipping:</span></dt>
                          <dd class="col-5"><span>{{ route.snapshot.queryParams['view'] === 'flashpay' 
                            ? (flashpayResponse?.shippingAmountRequested | currency) 
                            : (transaction?.paymentDetails?.totalShipping ?? 0.00 | currency) }}</span></dd>
                        </div>
                        <div class="row">
                          <dt class="col-7">
                            <strong>{{ 
                              route.snapshot.queryParams['view'] === 'preAuth'
                                ? 'Requested Amount:' 
                                : route.snapshot.queryParams['view'] === 'completeAuth'
                                  ? 'Total Authorized Amount:'
                                  : route.snapshot.queryParams['view'] === 'refund'
                                    ? 'Total Refunded Amount:'
                                    : 'Payment Total:'
                            }}</strong>
                          </dt>
                          <dd class="col-5">
                            <strong>{{ 
                              route.snapshot.queryParams['view'] === 'flashpay'
                                ? (Number(flashpayResponse?.paymentAmountRequested) | currency)
                                : route.snapshot.queryParams['view'] === 'preAuth'
                                  ? (transaction?.transactionResult?.authorizedAmount ?? 0.00 | currency)
                                  : route.snapshot.queryParams['view'] === 'refund'
                                    ? (transaction?.refundDetails?.refundAmount ?? 0.00 | currency)
                                    : (transaction?.paymentDetails?.totalCharge ?? 0.00 | currency) 
                            }}</strong>
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="success-footer">
  <div class="success-footer__actions">
    <button 
      mat-raised-button
      color="secondary-inversed" 
      type="button"
      (click)="viewReceipt(transaction!)"
      [style.display]="route.snapshot.queryParams['view'] === 'flashpay' ? 'none' : 'block'" 
      [disabled]="!transaction?.transactionId"
    >
      View Receipt
    </button>
    <button 
      mat-raised-button 
      color="secondary-inversed"
      (click)="sendReceipt(transaction!)"
      [style.display]="route.snapshot.queryParams['view'] === 'flashpay' ? 'none' : 'block'"
    >Send a Copy</button>
    <button
      *ngIf="!isTransactionSuccess && transaction?.transactionId"
      mat-raised-button
      color="secondary-inversed"
      type="button"
      class="failure-guidance-button"
      (click)="viewFailureGuidance(transaction!.transactionId)"
    >
      <mat-icon>auto_awesome</mat-icon>
      View Failure Guidance
    </button>
    <button mat-raised-button color="primary" routerLink="/payment/collect">Collect Another Payment</button>
  </div>
</div>

}
}
